import { render, staticRenderFns } from "./BookingFormExtras.vue?vue&type=template&id=61367b8a&"
import script from "./BookingFormExtras.vue?vue&type=script&lang=js&"
export * from "./BookingFormExtras.vue?vue&type=script&lang=js&"
import style0 from "./BookingFormExtras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
